import React from 'react'

export interface SVGLinkedinProps {
  width?: string;
  height?: string;
  color?: string;
}

export const SVGLinkedin = ({
  width = '32',
  height = '32',
  color = '#000000',
}: SVGLinkedinProps) => (
  <svg width={width} height={height} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M28.19 0H3.81A3.81 3.81 0 0 0 0 3.81v24.38A3.81 3.81 0 0 0 3.81 32h24.38A3.81 3.81 0 0 0 32 28.19V3.81A3.81 3.81 0 0 0 28.19 0M9.906 12.19v14.477H5.333V12.19zM5.333 7.978c0-1.067.915-1.882 2.286-1.882s2.232.815 2.286 1.882c0 1.067-.854 1.928-2.286 1.928-1.371 0-2.286-.861-2.286-1.928m21.334 18.69h-4.572v-7.62c0-1.523-.762-3.047-2.666-3.078h-.061c-1.844 0-2.606 1.57-2.606 3.079v7.619H12.19V12.19h4.57v1.951s1.471-1.95 4.428-1.95c3.024 0 5.478 2.08 5.478 6.293z" fill={color}/>
  </svg>
)
